<template>
  <div id="app">
    <!-- Hero Section -->
    <WeddingHero />

    <!-- Navigation Bar -->
<nav>
  <ul>
    <li><a href="#info" @click.prevent="scrollToSection('info', $event)">Info</a></li>
    <li><a href="#program" @click.prevent="scrollToSection('program', $event)">Program</a></li>
    <li><a href="#vigselprogram" @click.prevent="scrollToSection('vigselprogram', $event)">Vigsel</a></li>
    <li><a href="#meny" @click.prevent="scrollToSection('meny', $event)">Meny</a></li>

        <li>
          <a href="#kontakt" @click.prevent="scrollToSection('kontakt', $event)">Kontakt</a>
        </li>
      </ul>
    </nav>

<!-- Extra Info Section -->
<section id="info" class="section" :style="infoBg">
  <div class="content">
    <h2 class="section-heading">Välkommen</h2>
    <p>Varmt välkomna till bröllopet mellan <strong>Yvonne och Oscar</strong>!</p>

    <h2 class="section-heading">Information</h2>

    <h3 class="subheading">Klädsel</h3>
    <p>Kavaj</p>

    <h3 class="subheading">Presenter</h3>
    <p>Det viktigaste för oss är att ni är med och förgyller vår dag – vi undanber oss därför presenter.</p>

    <h3 class="subheading">Barn</h3>
    <p>Barn är varmt välkomna på vigseln. Middagen och festen är dock för vuxna, men ammande barn är självklart välkomna.</p>

    <h3 class="subheading">Att göra</h3>
    <p>
      På Flädie Vingård kan ni bada i poolen, strosa i Flädie by eller cykla till Bjärreds kallbadhus (4,5 km) med hotellets cyklar.
    </p>

    <h3 class="subheading">För er som ska bo över</h3>
    <p>
      Har ni anmält övernattning finns rum bokade i era namn. Incheckning sker från kl 15:00 fredag eller lördag. Betalning sker på plats och priset är 1850kr för en natt i dubbelrum eller 3330kr för två nätter.
    </p>
</div>
      </section>

<section id="plats" class="section" :style="platsBg" >
  <div class="content">
      <h2 class="section-heading">Plats</h2>
      <p>
        Bröllopet kommer att hållas på <strong>Flädie Mat och Vingård</strong>.<br />
        Adress: Flädie Mejeriväg 19, Bjärred.<br />
        Här hittar du vägbeskrivningar samt en karta för att enkelt hitta dit.
      </p>
      <div class="map-box">
        <LeafletMap />
      </div>
      <p>
      Sväng av på E6 vid trafikplats Flädie och följ skyltarna mot Flädie Vingård. Parkering finns på plats.
      </p>
    <h3>Hitta till Lomma Kyrka</h3>
    <p>Prästbergavägen 71, 234 35 Lomma</p>
    <ul>
      <li>Transport avgår från Flädie Mat & Vin kl 13:00.</li>
      <li>Buss tillbaka efter vigseln.</li>
      <li>Gott om parkering finns vid kyrkan.</li>
    </ul>
  </div>
</section>

    
  <section id="program" class="section" :style="programBg">
  <div class="content">
    <h2 class="section-heading">Program</h2>
       <div class="day">
          <h3 class="head">Fredag</h3>
          <p>
            För de som anländer på fredagen tjuvstartar vi med en härlig kväll på flädie vingård.
            Kvällen börjar vi med en välkomstskål sedan bjuds på hamburgare (dryck står man för själv). Senare startar ett musikquiz – så värm upp musikkunskaperna!
          </p>
          <div class="schedule">
            <div class="schedule-item">
              <p class="time">15:00</p>
              <p class="event">Tidigast Incheckning</p>
            </div>
            <div class="schedule-item">
              <p class="time">18:00</p>
              <p class="event">Maten börjar serveras</p>
            </div>
            <div class="schedule-item">
              <p class="time">20:00</p>
              <p class="event">Musikquiz</p>
            </div>
          </div>
        </div>

       <div class="day">
          <h3 class="head">Lördag</h3>

            <div class="schedule">
            <div class="schedule-item">
              <p class="time">08:00–10:30</p>
              <p class="event">Frukost för övernattande gäster</p>
            </div>
            <div class="schedule-item">
              <p class="time">13:30</p>
              <p class="event">Vigsel i Lomma kyrka</p>
            </div>
            <div class="schedule-item">
              <p class="time">14:30</p>
              <p class="event">Mingel med bubbel, tilltugg & lek</p>
            </div>
            <div class="schedule-item">
              <p class="time">16:00</p>
              <p class="event">Gruppfoto</p>
            </div>
            <div class="schedule-item">
              <p class="time">18:00</p>
              <p class="event">Middag</p>
            </div>
            <div class="schedule-item">
              <p class="time">22:00</p>
              <p class="event">Fest med DJ & vickning</p>
            </div>
          </div>
        </div>

    <p>Glöm inte att lägga till era favoritlåtar i vår <a href="https://open.spotify.com/playlist/6fft7IkN2bwv2KPoXwykZG?si=65703432b1b94c01&pt=85659186cf50cd8c3ef3ca44359fbde5" target="_blank">Spotifylista</a> senast <strong>14/8</strong>.</p>
    
       <div class="day">
          <h3 class="head">Söndag</h3>

            <div class="schedule">
            <div class="schedule-item">
              <p class="time">08:00–10:30</p>
              <p class="event">Frukost för övernattande gäster</p>
            </div>
            <div class="schedule-item">
              <p class="time">När det passar</p>
              <p class="event">Utchecking</p>
            </div>
          </div>
        </div>
  </div>
</section>

<section id="vigselprogram" class="section" :style="vigselBg">
  <div class="content-vigsel">
    <h2 class="section-heading">Vigselprogram</h2>

    <div class="schedule">
      <div class="vigsel-item">
        <p class="time">Klockringning</p>
        <p class="event"></p>
      </div>
      <div class="vigsel-item">
        <p class="time">Psalm </p>
        <p class="event"></p>
      </div>
      <div class="vigsel-item">
        <p class="time">Inledningsord</p>
        <p class="event">Lena Löwendahl</p>
      </div>
      <div class="vigsel-item">
        <p class="time">Musik</p>
        <p class="event">Hanna Forsblad</p>
      </div>
      <div class="vigsel-item">
        <p class="time">Löften</p>
        <p class="event"></p>
      </div>
      <div class="vigsel-item">
        <p class="time">Musik</p>
        <p class="event">Hanna Forsblad</p>
      </div>
      <div class="vigsel-item">
        <p class="time">Psalm</p>
        <p class="event"></p>
      </div>
      <div class="vigsel-item">
        <p class="time">Utgång</p>
        <p class="event"></p>
      </div>
    </div>

    <p style="margin-top: 20px;"><strong>OBS:</strong> Vigseln är mobilfri och fotograferas av vår fotograf.</p>
  </div>
</section>

<section id="meny" class="section" :style="menuBg">
  <div class="content-menu">
    <h2 class="section-heading">Meny</h2>

    <h3 class="subheading">Förrätt</h3>
    <p>
      Eldad pilgrimsmussla med ostronvinägrette, pancetta, krasseemulsion, potatisskum, friterat potatisnät
    </p>
    <p><strong>Dryck:</strong> Four Barrels</p>
    <p> --- </p>
    <h3 class="subheading">Varmrätt</h3>
    <p>
      Variation på skånsk hjort, picklad rödlök, svamp, morotsmaräng, sky, primörer, rostad potatis
    </p>
    <p><strong>Dryck:</strong> Leopres Renässans</p>
    <p> --- </p>
    <h3 class="subheading">Dessert</h3>
    <p>
      Bakad choklad, hallonsorbet, färska bär, chokladjord, havssalt, olivolja
    </p>
    <p><strong>Dryck:</strong> Ädelvän</p>
  </div>
</section>

    <!-- Kontakt Section -->
    <section id="kontakt" class="section" :style="boendeTalBg">
      <div class="content-vigsel">
      <h2 class="section-heading">Tal och sånt!</h2>
        <p>
          För att anmäla tal eller framträdanden hör av er till Johan och Alfred: </p><p>toastmaster.oscar.yvonne@gmail.com</p>
          <h3>Vi ser fram emot att ses i sommar!
          </h3>
      </div>
    </section>
  </div>
  
    <!-- OSA Section -->
    <section id="osa" class="section" :style="osaBg" v-if="false">
      <div class="content">
        <h2 class="section-heading">OSA</h2>
        <p>Fyll i dina uppgifter nedan för att OSA till vårt bröllop.</p>
        <form @submit.prevent="submitForm">
          <div class="form-group">
            <label for="guestName">Namn:</label>
            <input
              type="text"
              id="guestName"
              v-model="guestName"
              @input="filterNames"
              autocomplete="off"
              placeholder="Ange första namnet på inbjudningskurvertet..."
            />
            <ul class="suggestions" v-if="suggestions.length">
              <li
                v-for="suggestion in suggestions"
                :key="suggestion"
                @click="selectName(suggestion)"
              >
                {{ suggestion }}
              </li>
            </ul>
          </div>
          <div class="form-group">
            <label>
              <input type="checkbox" v-model="plusOne" />
              Jag tar med en +1
            </label>
          </div>

          <div class="form-group" v-if="plusOne">
            <label for="plusOneName">Namn på +1:</label>
            <input
              type="text"
              id="plusOneName"
              v-model="plusOneName"
              placeholder="Ange namnet på din gäst"
            />
          </div>
          <div class="form-group">
            <label>
              <input type="checkbox" v-model="attendFriday" />
              Deltar på fredag kväll
            </label>
          </div>
          <div class="form-group">
            <label>
              <input type="checkbox" v-model="attendSaturday" />
              Deltar på lördag
            </label>
          </div>
          <div class="form-group">
            <label>
              <input type="checkbox" v-model="hotelFriday" />
              Önskar hotellrum  Fredag - Lördag
            </label>
          </div>
          <div class="form-group">
            <label>
              <input type="checkbox" v-model="hotelSaturday" />
              Önskar hotellrum  Lördag - Söndag
            </label>
          </div>
          <div class="form-group">
          <label for="specialDiet">Specialkost / Allergier:</label>
          <input
            type="text"
            id="specialDiet"
            v-model="specialDiet"
            placeholder="T.ex. vegetarisk, nötallergi..."
          />
        </div>
          <button :disabled="!nameIsValid" type="submit">Skicka OSA</button>
        </form>
        <p v-if="guestName && !nameIsValid" style="color: red;">
        Använd första namnet på ibjudningskurvertet.
        </p>
      </div>
    </section>

</template>

<script>
import WeddingHero from './components/WeddingHero.vue'
import LeafletMap from './components/LeafletMap.vue'
import { db } from "@/firebase";
import { collection, addDoc, getDocs  } from "firebase/firestore";

export default {
  name: 'App',
  components: {
    WeddingHero,
    LeafletMap
  },
  data() {
  return {
    guestName: '',
    plusOne: false, // renamed from joiningSolo
    plusOneName: '', // new field for extra guest name
    specialDiet: '', // <- new field
    attendFriday: false,
    attendSaturday: false,
    hotelFriday: false,
    hotelSaturday: false,
    names: [],
    suggestions: []
  }
},
  computed: {
    nameIsValid() {
      const trimmed = this.guestName.trim().toLowerCase();
      return trimmed.length > 1 && this.names.some(name =>
        name.toLowerCase() === trimmed
      );
    },
    platsBg() {
      return {
        background: "url(" + require('@/assets/background-with-leaves-side.jpg') + ") no-repeat center center",
        backgroundAttachment: "fixed",
        backgroundSize: "cover"
      }
    },
    infoBg() {
      return {
        background: "url(" + require('@/assets/bunch-small-flowers.jpg') + ") no-repeat center center",
        backgroundAttachment: "fixed",
        backgroundSize: "cover"
      }
    },
    programBg() {
      return {
        background: "url(" + require('@/assets/pink-tulip-blue.jpg') + ") no-repeat center center",
        backgroundAttachment: "fixed",
        backgroundSize: "cover"
      }
    },
    menuBg() {
      return {
        background: "url(" + require('@/assets/romantic-background-with-flower.jpg') + ") no-repeat center center",
        backgroundAttachment: "fixed",
        backgroundSize: "cover"
      }
    },
    vigselBg() {
      return {
        background: "url(" + require('@/assets/cute-composition-flower-with-orange-details-leaves.jpg') + ") no-repeat center center",
        backgroundAttachment: "fixed",
        backgroundSize: "cover"
      }
    },
    boendeTalBg() {
      return {
        background: "url(" + require('@/assets/white-gerbera-flower-with-blue-cutout-paper-yellow-background.jpg') + ") no-repeat center center",
        backgroundAttachment: "fixed",
        backgroundSize: "cover"
      }
    }
  },
  watch: {
    plusOne(newVal) {
      if (!newVal) {
        this.plusOneName = '';
      }
    }
  },
  async created() {
    const querySnapshot = await getDocs(collection(db, "guest_names")); // <- updated name
    this.names = querySnapshot.docs
      .map(doc => doc.data().name)
      .filter(name => typeof name === 'string'); // extra safety
  },
  methods: {
    filterNames() {
      if (this.guestName.length > 2) {
        const query = this.guestName.toLowerCase();
        this.suggestions = this.names.filter(name =>
          name.toLowerCase().includes(query)
        );
      } else {
        this.suggestions = [];
      }
    },
    selectName(name) {
      this.guestName = name;
      this.suggestions = [];
    },
    async submitForm() {
      if (this.nameIsValid) {
        try {
          await addDoc(collection(db, "guests"), {
            guestName: this.guestName,
            plusOne: this.plusOne,
            plusOneName: this.plusOneName,
            specialDiet: this.specialDiet,
            attendFriday: this.attendFriday,
            attendSaturday: this.attendSaturday,
            hotelFriday: this.hotelFriday,
            hotelSaturday: this.hotelSaturday,
            timestamp: new Date()
          });
          alert("OSA skickat! Tack!");
        } catch (error) {
          console.error("Error writing to Firestore:", error);
          alert("Något gick fel. Försök igen senare.");
        }
      } else {
        alert("Något gick fel. Försök igen senare. Skicka ett SMS till Oscar :)");
      }
    },
    scrollToSection(sectionId, event) {
      if (event && event.currentTarget) {
        const navLink = event.currentTarget;
        navLink.classList.add('nav-click');
        setTimeout(() => {
          if (navLink) {
            navLink.classList.remove('nav-click');
          }
        }, 300);
      }
      const target = document.getElementById(sectionId);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth' });
      }
    }
  },
  mounted() {
    const sections = document.querySelectorAll('.section');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
          }
        });
      },
      { threshold: 0.2 }
    );
    sections.forEach(section => observer.observe(section));
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Dancing+Script:wght@700&family=Playfair+Display:wght@700&display=swap');
@import '@/assets/fonts.css';

html {
  scroll-behavior: smooth;
}
body {
  font-family: 'Helvetica', sans-serif;

  font-size: 22px;
  margin: 0;
  padding: 0;
}

/* Navigation Bar */
nav {
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;
}
nav ul {
  list-style: none;
  margin: 0;
  padding: 10px;
  display: flex;
  justify-content: center;
}
nav ul li {
  margin: 0 15px;
}
nav ul li a {
  text-decoration: none;
  color: rgb(70,70,70);
  font-weight: bold;
  transition: transform 0.3s ease;
}
nav ul li a.nav-click {
  animation: navClickAnim 0.3s ease;
}
@keyframes navClickAnim {
  0% { transform: scale(1); }
  50% { transform: scale(1.1); }
  100% { transform: scale(1); }
}

/* Section Styling with Parallax and Reduced Vertical Extent */
.section {
  font-family: 'Helvetica', sans-serif;
  position: relative;
  padding: 40px 20px 20px;
  min-height: 60vh;
  scroll-margin-top: 80px;
  filter: grayscale(0.5) brightness(1.9);
}
.section::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.4);
  z-index: 1;
}
.content {
  position: relative;
  z-index: 2;
  max-width: 1200px;
  margin: 0 auto;

  color: rgb(35, 35, 35, 255.0);
  background: rgba(133, 133, 133, 0.8);
  border-radius: 6px;
  padding: 30px;
  box-shadow: 0 4px 10px rgba(12, 0, 0, 0.0);
  max-width: 700px;
}.content-menu {
  position: relative;
  z-index: 2;
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
  background: rgba(133, 133, 133, 0.8);
  border-radius: 6px;
  padding: 10px;
  box-shadow: 0 4px 10px rgba(12, 0, 0, 0.0);
  max-width: 700px;
}.content-vigsel {
  position: relative;
  z-index: 2;
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
  background: rgba(133, 133, 133, 0.8);
  border-radius: 6px;
  padding: 10px;
  box-shadow: 0 4px 10px rgba(12, 0, 0, 0.0);
  max-width: 700px;
}
/* Section Headings */
.section-heading {
  font-family: 'Cochocib Script', serif;
  font-size: 5.5rem;
  margin-bottom: 20px;
  color: black;
}

/* Flex container for Plats & OSA section */
.flex-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}
.left, .right {
  flex: 1 1 300px;
}

/* Map Box Styling */
.map-box {
  margin-top: 20px;
  border: 2px solid #fff;
  border-radius: 8px;
  overflow: hidden;
}

/* Schedule Styles in Program Section */
.day .head{
  font-family: 'Cochocib Script', serif;
  font-size: 3.5rem;
}

.subheading {
  font-family: 'Helvetica', sans-serif;
  font-size: 1.2rem;
  font-weight: bold;
  color: black;
  font-style: oblique;
  margin-bottom: 0.1em;
  margin-top: 1em;
}
.schedule {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.schedule-item {
  display: flex;
  align-items: center;
  gap: 15px;
  font-size: 1.0rem;
}
.vigsel-item .time {
  font-family: 'Dancing Script', sans-serif;
  font-size: 1.2rem;
  
}
.schedule-item .time {
  font-family: 'Dancing Script', sans-serif;
  font-size: 1.2rem;
  width: 120px;
}
.schedule-item .event {
  flex: 1;
}
/* Map Box Styling */
.map-box {
  margin-top: 20px;
  filter: brightness(0.54);
  border: 2px solid #fff;
  border-radius: 8px;
  overflow: hidden;
}
/* Form Styling */
.form-group {
  margin-bottom: 8px;
  position: relative;
}
label {
  display: block;
  margin-bottom: 4px;
}
input[type="text"] {
  width: 90%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1.1rem;
}
input[type="checkbox"] {
  margin-right: 10px;
  accent-color: black;
}
button {
  padding: 10px 20px;
  background: rgb(255, 250, 250, 255.0);;
  color: black;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1.1rem;
}
button:hover {
  background:  rgb(33, 123, 33);;
}
.suggestions {
  list-style: none;
  padding: 0;
  margin: 0;
  border: 1px solid #ccc;
  background: white;
  max-height: 150px;
  overflow-y: auto;
  position: absolute;
  width: 100%;
  z-index: 10;
}
.suggestions li {
  padding: 8px;
  cursor: pointer;
}
.suggestions li:hover {
  background: #eee;
}

.section.in-view {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.6s ease-out, transform 0.6s ease-out;
}

@media (max-width: 400px) {
  nav ul {
    flex-direction: column;
    align-items: center;
  }
  nav ul li {
    margin: 10px 0;
  }
  .flex-container {
    flex-direction: column;
  }
}
</style>
